// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.wrapper-history {
  display: flex;
  flex-direction: column;
  position: relative;
  height: auto !important;
  overflow: visible !important;
}
.wrapper-history .wrapper-search {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0px;
}
.wrapper-history .wrapper-search__container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.wrapper-history .wrapper-search__size {
  display: flex;
  align-items: center;
  gap: 10px;
}
.wrapper-history .wrapper-search__search {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 28px;
  border: 1px solid #1D283C;
  border-radius: 4px;
  cursor: pointer;
}
.wrapper-history .wrapper-search .navbar-upload {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 320px;
  height: 40px;
  position: relative;
  margin-left: 15px;
}
.wrapper-history .wrapper-search .navbar-upload .wrapper-upload-mini {
  width: 160px;
  height: 30px;
  flex-shrink: 0;
  border: 2px dashed #e8e8e8;
  border-radius: 8px;
  background-color: #fafafa;
  transition: all 0.3s ease;
  cursor: pointer;
}
.wrapper-history .wrapper-search .navbar-upload .wrapper-upload-mini:hover {
  border-color: #1890ff;
  background-color: #f0f5ff;
}
.wrapper-history .wrapper-search .navbar-upload .wrapper-upload-mini__content {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 12px;
}
.wrapper-history .wrapper-search .navbar-upload .wrapper-upload-mini__text {
  font-size: 13px;
  color: #666;
  white-space: nowrap;
}
.wrapper-history .wrapper-search .navbar-upload .upload-progress {
  position: absolute;
  left: 170px;
  top: -5px;
  width: 150px;
  height: 40px;
  background: transparent;
  pointer-events: auto;
  z-index: 1;
}
.wrapper-history .wrapper-search .navbar-upload .upload-progress__header {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
}
.wrapper-history .wrapper-search .navbar-upload .upload-progress__header .ant-progress {
  width: 100px;
}
.wrapper-history .wrapper-search .navbar-upload .upload-progress__header .ant-progress .ant-progress-outer {
  height: 100%;
}
.wrapper-history .wrapper-search .navbar-upload .upload-progress__header .ant-progress .ant-progress-text {
  position: absolute !important;
}
.wrapper-history .ant-select-selector {
  border: 1px solid #1D283C !important;
}
[data-theme=dark] .wrapper-history .ant-select-selector {
  border-color: var(--color-field-border-hover) !important;
}
.wrapper-history .ant-select-selection-item {
  font-size: 18px;
  font-weight: 700;
  color: #1D283C;
}
[data-theme=dark] .wrapper-history .ant-select-selection-item {
  color: var(--color-text);
}
.wrapper-history .ant-select-arrow {
  font-size: 18px;
}
.wrapper-history .dragging-over::after {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(24, 144, 255, 0.1);
  border: 2px dashed #1890ff;
  pointer-events: none;
  z-index: 1;
}
.wrapper-history .ant-table-wrapper {
  width: 100%;
}
.wrapper-history .ant-table .ant-table-container {
  overflow: visible;
}
.wrapper-history .ant-table .ant-table-body {
  overflow: visible !important;
}
.wrapper-history .ant-progress-outer {
  padding-right: 0 !important;
  margin-right: 0 !important;
}
.wrapper-history .ant-progress-inner {
  border-radius: 5px !important;
}
.wrapper-history .ant-progress-bg {
  border-radius: 5px !important;
  height: 34px !important;
}
.wrapper-history.horizontal .history-content {
  flex: 1 1;
  overflow: auto;
}
.wrapper-history.horizontal .horizontal-split {
  border-top: 1px solid #d9d9d9;
  background: #fff;
  margin-top: 16px;
}
.wrapper-history.horizontal .horizontal-split .react-resizable-handle {
  background: #f0f0f0;
  height: 10px;
  width: 100%;
  cursor: row-resize;
  position: absolute;
  top: 0;
  transform: translateY(-50%);
}
.wrapper-history.horizontal .horizontal-split .react-resizable-handle:hover {
  background: #d9d9d9;
}
.wrapper-history.horizontal .horizontal-split .split-content {
  height: 100%;
  padding: 16px;
  overflow: auto;
}

.ant-tooltip-inner {
  background-color: red !important;
  color: white;
}

.ant-tooltip-arrow::before {
  background-color: red !important;
}

.right-button-group {
  display: flex;
  align-items: center;
  gap: 25px;
  margin-right: 20px;
}

.icon-button {
  cursor: pointer;
  padding: 2px;
  border-radius: var(--radius-md);
  transition: background var(--duration-base) var(--easing-standard), border-color var(--duration-base) var(--easing-standard), opacity var(--duration-base) var(--easing-standard);
  border: 1px solid transparent;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.7;
  color: var(--color-text-muted);
}
.icon-button:hover {
  background-color: var(--color-bg-subtle);
  border-color: var(--color-border);
  opacity: 1;
}
.icon-button svg {
  opacity: 0.7;
  transition: opacity 0.3s ease;
  width: 30px;
  height: 30px;
  color: var(--color-text);
}

.ant-dropdown-menu {
  padding: 4px 0;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.ant-dropdown-menu .ant-dropdown-menu-item {
  padding: 8px 16px;
  font-size: 14px;
  color: #666;
  transition: all 0.3s;
}
.ant-dropdown-menu .ant-dropdown-menu-item:hover {
  background-color: #f5f5f5;
  color: #1890ff;
}
.ant-dropdown-menu .ant-dropdown-menu-item-selected {
  color: #1890ff;
  background-color: #e6f7ff;
}

.stability-progress-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  cursor: pointer;
  padding: 0;
}

.stability-progress-bar {
  width: 100%;
  height: 30px;
  background-color: var(--color-bg-emphasis);
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
}
.stability-progress-bar .stability-progress-fill {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  transition: width 0.3s ease;
  border-radius: 4px;
}

.stability-progress-text-inside {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 500;
  text-shadow: 0 0 2px rgba(0, 0, 0, 0.7);
  z-index: 2;
  width: 100%;
  pointer-events: none;
}

.stability-progress-wrapper:hover .stability-progress-bar {
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.2);
}

.ant-table-cell .stability-progress-wrapper {
  margin: 0;
  padding: 0;
  height: 100%;
}

.ant-table-tbody .ant-table-cell {
  padding: 8px 16px !important;
}

.ant-table-tbody > tr:hover > td {
  background-color: var(--color-bg-emphasis) !important;
  color: var(--color-text) !important;
}

.ant-table-tbody > tr:hover {
  border-radius: 4px;
  overflow: hidden;
}

.ant-table-tbody > tr:hover > td:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.ant-table-tbody > tr:hover > td:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.ant-table-tbody > tr > td {
  height: 55px;
  padding: 8px 16px !important;
}

.stability-progress-bar {
  width: 100%;
  height: 30px;
  background-color: var(--color-bg-emphasis);
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
}

.wrapper-table {
  overflow: visible !important;
  height: auto !important;
}
.wrapper-table .ant-table {
  overflow: visible !important;
}
.wrapper-table .ant-table .ant-table-body {
  overflow: visible !important;
  height: auto !important;
}
.wrapper-table .ant-table .ant-table-container {
  overflow: visible !important;
  height: auto !important;
}
.wrapper-table .ant-table .ant-table-content {
  overflow: visible !important;
}

.history-container {
  height: auto !important;
  min-height: calc(100vh - 64px);
  overflow: visible !important;
}
.history-container__content {
  height: auto !important;
  overflow: visible !important;
}

.stability-progress-bar {
  height: 30px;
}

body, html {
  overflow-y: auto !important;
  height: auto !important;
}

.ant-layout, .ant-layout-content {
  overflow: visible !important;
  height: auto !important;
}

.horizontal-split {
  display: none !important;
  overflow: hidden !important;
}
.horizontal-split.visible {
  display: block !important;
}

.react-resizable {
  position: relative;
  overflow: hidden !important;
}

.wrapper-history.p-16 {
  margin-top: 0;
}

/* 레이아웃 관련 스타일 */
.history-page {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.history-page.horizontal {
  overflow: hidden;
}

.history-horizontal-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.history-content-top {
  overflow: auto;
  border-bottom: 1px solid #e8e8e8;
  position: relative;
}

.history-content-bottom {
  flex: 1 1;
  overflow: auto;
  padding: 16px;
  background-color: #f5f5f5;
}

.resize-handle {
  width: 100%;
  height: 10px;
  background-color: #f0f0f0;
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: row-resize;
  color: #999;
}
.resize-handle:hover {
  background-color: #e0e0e0;
}

.selected-item-preview h3 {
  margin-bottom: 16px;
  font-size: 18px;
}
.selected-item-preview .preview-content {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.selected-item-preview .preview-item {
  background-color: white;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: calc(33.33% - 16px);
  min-width: 250px;
}
.selected-item-preview .preview-item h4 {
  margin-bottom: 8px;
  font-weight: 500;
}
.selected-item-preview .preview-item p {
  margin-bottom: 12px;
  color: #666;
}

.no-selection {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: #999;
  font-size: 16px;
}

/* 반응형 스타일 */
@media (max-width: 768px) {
  .selected-item-preview .preview-item {
    width: calc(50% - 16px);
  }
}
@media (max-width: 576px) {
  .selected-item-preview .preview-item {
    width: 100%;
  }
}
/* 스크롤바 디자인 */
.custom-scrollbar {
  /* Firefox */
  scrollbar-width: thin;
  /* Webkit 브라우저 (Chrome, Safari 등) */
}
.custom-scrollbar::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  display: block;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.3);
}
.custom-scrollbar::-webkit-scrollbar-button {
  display: none !important;
  height: 0 !important;
  width: 0 !important;
}

/* iframe 내부 스크롤바 스타일을 위한 추가 코드 */
iframe.custom-scrollbar {
  border: none;
}

.history-header {
  padding: 8px 16px 8px 16px !important; /* 상단 16px, 좌우 16px, 하단 8px로 조정 */
  margin-bottom: 0 !important; /* 하단 마진 제거 */
}

/* 또는 p-16 클래스를 오버라이드 */
.history-header.p-16 {
  padding-bottom: 8px !important; /* 하단 패딩만 8px로 줄임 */
}`, "",{"version":3,"sources":["webpack://./src/pages/History/HistoryStyled.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;EACA,sBAAA;EAEA,kBAAA;EACA,uBAAA;EACA,4BAAA;AACF;AAKE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAHJ;AAKI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAHN;AAMI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAJN;AAOI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AALN;AAQI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AANN;AAQM;EACE,YAAA;EACA,YAAA;EACA,cAAA;EACA,0BAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,eAAA;AANR;AAQQ;EACE,qBAAA;EACA,yBAAA;AANV;AASQ;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;AAPV;AAUQ;EACE,eAAA;EACA,WAAA;EACA,mBAAA;AARV;AAYM;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;EACA,UAAA;AAVR;AAYQ;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAVV;AAYU;EACE,YAAA;AAVZ;AAWY;EACE,YAAA;AATd;AAYY;EACE,6BAAA;AAVd;AAoBE;EACE,oCAAA;AAlBJ;AAoBI;EACE,wDAAA;AAlBN;AAqBE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAnBJ;AAqBI;EACE,wBAAA;AAnBN;AAsBE;EACE,eAAA;AApBJ;AAwBI;EACE,WAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yCAAA;EACA,0BAAA;EACA,oBAAA;EACA,UAAA;AAtBN;AA0BE;EACE,WAAA;AAxBJ;AA4BI;EACE,iBAAA;AA1BN;AA6BI;EACE,4BAAA;AA3BN;AAgCE;EACE,2BAAA;EACA,0BAAA;AA9BJ;AAiCE;EACE,6BAAA;AA/BJ;AAkCE;EACE,6BAAA;EACA,uBAAA;AAhCJ;AAoCI;EACE,SAAA;EACA,cAAA;AAlCN;AAqCI;EACE,6BAAA;EACA,gBAAA;EACA,gBAAA;AAnCN;AAqCM;EACE,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,2BAAA;AAnCR;AAqCQ;EACE,mBAAA;AAnCV;AAuCM;EACE,YAAA;EACA,aAAA;EACA,cAAA;AArCR;;AA4CA;EACE,gCAAA;EACA,YAAA;AAzCF;;AA8CE;EACE,gCAAA;AA3CJ;;AA+CA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AA5CF;;AA+CA;EACE,eAAA;EACA,YAAA;EACA,+BAAA;EACA,iLAAA;EAGA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,8BAAA;AA9CF;AAgDE;EACE,wCAAA;EACA,iCAAA;EACA,UAAA;AA9CJ;AAiDE;EACE,YAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;AA/CJ;;AAoDA;EACE,cAAA;EACA,kBAAA;EACA,yCAAA;AAjDF;AAmDE;EACE,iBAAA;EACA,eAAA;EACA,WAAA;EACA,oBAAA;AAjDJ;AAmDI;EACE,yBAAA;EACA,cAAA;AAjDN;AAoDI;EACE,cAAA;EACA,yBAAA;AAlDN;;AAuDA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;AApDF;;AAuDA;EACE,WAAA;EACA,YAAA;EAGA,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,8CAAA;AAtDF;AAwDE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;AAtDJ;;AA0DA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,uCAAA;EACA,UAAA;EACA,WAAA;EACA,oBAAA;AAvDF;;AA2DA;EACE,8CAAA;AAxDF;;AA4DA;EACE,SAAA;EACA,UAAA;EACA,YAAA;AAzDF;;AA6DA;EACE,4BAAA;AA1DF;;AA+DA;EACE,qDAAA;EACA,mCAAA;AA5DF;;AAgEA;EACE,kBAAA;EACA,gBAAA;AA7DF;;AAiEA;EACE,2BAAA;EACA,8BAAA;AA9DF;;AAiEA;EACE,4BAAA;EACA,+BAAA;AA9DF;;AAkEA;EACE,YAAA;EACA,4BAAA;AA/DF;;AAmEA;EACE,WAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,8CAAA;AAhEF;;AAoEA;EACE,4BAAA;EACA,uBAAA;AAjEF;AAmEE;EACE,4BAAA;AAjEJ;AAoEI;EACE,4BAAA;EACA,uBAAA;AAlEN;AAsEI;EACE,4BAAA;EACA,uBAAA;AApEN;AAwEI;EACE,4BAAA;AAtEN;;AA4EA;EACE,uBAAA;EACA,8BAAA;EACA,4BAAA;AAzEF;AA4EE;EACE,uBAAA;EACA,4BAAA;AA1EJ;;AA+EA;EACE,YAAA;AA5EF;;AAgFA;EACE,2BAAA;EACA,uBAAA;AA7EF;;AAiFA;EACE,4BAAA;EACA,uBAAA;AA9EF;;AAkFA;EACE,wBAAA;EACA,2BAAA;AA/EF;AAiFE;EACE,yBAAA;AA/EJ;;AAoFA;EACE,kBAAA;EACA,2BAAA;AAjFF;;AAoFA;EACE,aAAA;AAjFF;;AAoFA,gBAAA;AACA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AAjFF;AAmFE;EACE,gBAAA;AAjFJ;;AAqFA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAlFF;;AAqFA;EACE,cAAA;EACA,gCAAA;EACA,kBAAA;AAlFF;;AAqFA;EACE,SAAA;EACA,cAAA;EACA,aAAA;EACA,yBAAA;AAlFF;;AAqFA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,gCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AAlFF;AAoFE;EACE,yBAAA;AAlFJ;;AAuFE;EACE,mBAAA;EACA,eAAA;AApFJ;AAuFE;EACE,aAAA;EACA,eAAA;EACA,SAAA;AArFJ;AAwFE;EACE,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;EACA,0BAAA;EACA,gBAAA;AAtFJ;AAwFI;EACE,kBAAA;EACA,gBAAA;AAtFN;AAyFI;EACE,mBAAA;EACA,WAAA;AAvFN;;AA4FA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AAzFF;;AA4FA,YAAA;AACA;EACE;IACE,uBAAA;EAzFF;AACF;AA4FA;EACE;IACE,WAAA;EA1FF;AACF;AA6FA,aAAA;AACA;EACE,YAAA;EACA,qBAAA;EAGA,mCAAA;AA7FF;AA8FE;EACE,UAAA;EACA,WAAA;EACA,cAAA;AA5FJ;AA+FE;EACE,uBAAA;AA7FJ;AAgGE;EACE,oCAAA;EACA,kBAAA;AA9FJ;AAgGI;EACE,oCAAA;AA9FN;AAkGE;EACE,wBAAA;EACA,oBAAA;EACA,mBAAA;AAhGJ;;AAoGA,iCAAA;AACA;EACE,YAAA;AAjGF;;AAoGA;EACE,qCAAA,EAAA,iCAAA;EACA,2BAAA,EAAA,aAAA;AAjGF;;AAoGA,uBAAA;AACA;EACE,8BAAA,EAAA,mBAAA;AAjGF","sourcesContent":[".wrapper-history {\n  display: flex;\n  flex-direction: column;\n  // gap: 35px;\n  position: relative;\n  height: auto !important;\n  overflow: visible !important;\n\n  // .page-title styling provided globally in src/styles/global.scss\n  // (accent bar + bottom hairline + 64px left padding). Do not redefine here —\n  // doing so increases specificity past `.page-title.p-16` and breaks the layout.\n\n  .wrapper-search {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 0px;\n    \n    &__container {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      width: 100%;\n    }\n\n    &__size {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n    }\n\n    &__search {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 50px;\n      height: 28px;\n      border: 1px solid #1D283C;\n      border-radius: 4px;\n      cursor: pointer;\n    }\n\n    .navbar-upload {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      width: 320px;\n      height: 40px;\n      position: relative;\n      margin-left: 15px;\n\n      .wrapper-upload-mini {\n        width: 160px;\n        height: 30px;\n        flex-shrink: 0;\n        border: 2px dashed #e8e8e8;\n        border-radius: 8px;\n        background-color: #fafafa;\n        transition: all 0.3s ease;\n        cursor: pointer;\n\n        &:hover {\n          border-color: #1890ff;\n          background-color: #f0f5ff;\n        }\n\n        &__content {\n          height: 100%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          gap: 8px;\n          padding: 0 12px;\n        }\n\n        &__text {\n          font-size: 13px;\n          color: #666;\n          white-space: nowrap;\n        }\n      }\n\n      .upload-progress {\n        position: absolute;\n        left: 170px;\n        top: -5px;\n        width: 150px;\n        height: 40px;\n        background: transparent;\n        pointer-events: auto;\n        z-index: 1;\n        \n        &__header {\n          width: 100%;\n          height: 100%;\n          display: flex;\n          align-items: center;\n          gap: 8px;\n          \n          .ant-progress {\n            width: 100px;\n            .ant-progress-outer {\n              height: 100%;\n            }\n            \n            .ant-progress-text {\n              position: absolute !important;\n            }\n          }\n        }\n      }\n    }\n  }\n  // 진한 남색(#1D283C)은 라이트에서 의도된 강조라 그대로 둡니다. 다만 다크모드의\n  // 배경(slate-900)과는 거의 같은 색이라 테두리와 글자가 통째로 사라지므로,\n  // 다크에서만 필드 토큰으로 바꿔 줍니다.\n  .ant-select-selector {\n    border: 1px solid #1D283C !important;\n\n    [data-theme=\"dark\"] & {\n      border-color: var(--color-field-border-hover) !important;\n    }\n  }\n  .ant-select-selection-item {\n    font-size: 18px;\n    font-weight: 700;\n    color: #1D283C;\n\n    [data-theme=\"dark\"] & {\n      color: var(--color-text);\n    }\n  }\n  .ant-select-arrow {\n    font-size: 18px;\n  }\n\n  .dragging-over {\n    &::after {\n      content: '';\n      position: fixed;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background-color: rgba(24, 144, 255, 0.1);\n      border: 2px dashed #1890ff;\n      pointer-events: none;\n      z-index: 1;\n    }\n  }\n\n  .ant-table-wrapper {\n    width: 100%;\n  }\n\n  .ant-table {\n    .ant-table-container {\n      overflow: visible;\n    }\n    \n    .ant-table-body {\n      overflow: visible !important;\n    }\n  }\n\n  // Progress bar styles\n  .ant-progress-outer {\n    padding-right: 0 !important;\n    margin-right: 0 !important;\n  }\n\n  .ant-progress-inner {\n    border-radius: 5px !important;\n  }\n\n  .ant-progress-bg {\n    border-radius: 5px !important;\n    height: 34px !important;\n  }\n\n  &.horizontal {\n    .history-content {\n      flex: 1;\n      overflow: auto;\n    }\n\n    .horizontal-split {\n      border-top: 1px solid #d9d9d9;\n      background: #fff;\n      margin-top: 16px;\n      \n      .react-resizable-handle {\n        background: #f0f0f0;\n        height: 10px;\n        width: 100%;\n        cursor: row-resize;\n        position: absolute;\n        top: 0;\n        transform: translateY(-50%);\n\n        &:hover {\n          background: #d9d9d9;\n        }\n      }\n\n      .split-content {\n        height: 100%;\n        padding: 16px;\n        overflow: auto;\n      }\n    }\n  }\n}\n\n// Tooltip\n.ant-tooltip-inner {\n  background-color: red !important;\n  color: white;\n}\n\n// Tooltip Arrow\n.ant-tooltip-arrow {\n  &::before {\n    background-color: red !important;\n  }\n}\n\n.right-button-group {\n  display: flex;\n  align-items: center;\n  gap: 25px;\n  margin-right: 20px;\n}\n\n.icon-button {\n  cursor: pointer;\n  padding: 2px;\n  border-radius: var(--radius-md);\n  transition: background var(--duration-base) var(--easing-standard),\n              border-color var(--duration-base) var(--easing-standard),\n              opacity var(--duration-base) var(--easing-standard);\n  border: 1px solid transparent;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0.7;\n  color: var(--color-text-muted);\n\n  &:hover {\n    background-color: var(--color-bg-subtle);\n    border-color: var(--color-border);\n    opacity: 1;\n  }\n\n  svg {\n    opacity: 0.7;\n    transition: opacity 0.3s ease;\n    width: 30px;\n    height: 30px;\n    color: var(--color-text);\n  }\n}\n\n// 드롭다운 메뉴 스타일\n.ant-dropdown-menu {\n  padding: 4px 0;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n\n  .ant-dropdown-menu-item {\n    padding: 8px 16px;\n    font-size: 14px;\n    color: #666;\n    transition: all 0.3s;\n\n    &:hover {\n      background-color: #f5f5f5;\n      color: #1890ff;\n    }\n\n    &-selected {\n      color: #1890ff;\n      background-color: #e6f7ff;\n    }\n  }\n}\n\n.stability-progress-wrapper {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  padding: 0;\n}\n\n.stability-progress-bar {\n  width: 100%;\n  height: 30px;\n  // Tokenized so the unfilled portion (the \"찌꺼기\" the user saw) flips to a\n  // dark slate in dark mode instead of bleeding white-grey on the page bg.\n  background-color: var(--color-bg-emphasis);\n  border-radius: 4px;\n  overflow: hidden;\n  position: relative;\n  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);\n  \n  .stability-progress-fill {\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    transition: width 0.3s ease;\n    border-radius: 4px;\n  }\n}\n\n.stability-progress-text-inside {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: 500;\n  text-shadow: 0 0 2px rgba(0, 0, 0, 0.7);\n  z-index: 2;\n  width: 100%;\n  pointer-events: none; // 텍스트가 마우스 이벤트를 방해하지 않도록\n}\n\n// 호버 효과\n.stability-progress-wrapper:hover .stability-progress-bar {\n  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n// 테이블 셀 내부 패딩 조정\n.ant-table-cell .stability-progress-wrapper {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n}\n\n// 테이블 셀 자체의 패딩 조정\n.ant-table-tbody .ant-table-cell {\n  padding: 8px 16px !important;\n}\n\n// 테이블 행 호버 시 스타일 — 토큰화 (라이트/다크 자동 전환).\n// 다크에서는 slate-700 톤 + 흰색 글자, 라이트에서는 slate-200 톤 + 진한 글자.\n.ant-table-tbody > tr:hover > td {\n  background-color: var(--color-bg-emphasis) !important;\n  color: var(--color-text) !important;\n}\n\n// 테이블 행 호버 시 border-radius 추가\n.ant-table-tbody > tr:hover {\n  border-radius: 4px; // 여기서 테이블 행 호버 시 border-radius 설정\n  overflow: hidden;\n}\n\n// 첫 번째 셀과 마지막 셀의 border-radius 설정\n.ant-table-tbody > tr:hover > td:first-child {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n\n.ant-table-tbody > tr:hover > td:last-child {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n// 테이블 행의 높이 조절\n.ant-table-tbody > tr > td {\n  height: 55px;\n  padding: 8px 16px !important;\n}\n\n// 또는 안정성 그래프의 높이로 간접적으로 행 높이 조절\n.stability-progress-bar {\n  width: 100%;\n  height: 30px; // 여기서 그래프 높이를 조절하면 행 높이에 영향을 줌\n  background-color: var(--color-bg-emphasis);\n  border-radius: 4px;\n  overflow: hidden;\n  position: relative;\n  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n// 테이블 컨테이너 스타일 수정\n.wrapper-table {\n  overflow: visible !important;\n  height: auto !important;\n  \n  .ant-table {\n    overflow: visible !important;\n    \n    // 테이블 본문 스크롤 제어\n    .ant-table-body {\n      overflow: visible !important;\n      height: auto !important;\n    }\n    \n    // 테이블 컨테이너 스크롤 제어\n    .ant-table-container {\n      overflow: visible !important;\n      height: auto !important;\n    }\n    \n    // 테이블 내용 스크롤 제어\n    .ant-table-content {\n      overflow: visible !important;\n    }\n  }\n}\n\n// 페이지 컨테이너 스타일 수정\n.history-container {\n  height: auto !important;\n  min-height: calc(100vh - 64px);\n  overflow: visible !important;\n  \n  // 내부 컨텐츠가 많을 때만 스크롤 표시\n  &__content {\n    height: auto !important;\n    overflow: visible !important;\n  }\n}\n\n// 안정성 그래프 높이 조절\n.stability-progress-bar {\n  height: 30px; // 그래프 높이 유지\n}\n\n// 전체 레이아웃 스크롤 제어\nbody, html {\n  overflow-y: auto !important;\n  height: auto !important;\n}\n\n// 스크롤 관련 추가 수정\n.ant-layout, .ant-layout-content {\n  overflow: visible !important;\n  height: auto !important;\n}\n\n// 추가할 스타일\n.horizontal-split {\n  display: none !important; // 기본적으로 숨김\n  overflow: hidden !important;\n  \n  &.visible {\n    display: block !important; // 보여질 때만 표시\n  }\n}\n\n// ResizableBox 관련 스타일 수정\n.react-resizable {\n  position: relative;\n  overflow: hidden !important;\n}\n\n.wrapper-history.p-16 {\n  margin-top: 0;\n}\n\n/* 레이아웃 관련 스타일 */\n.history-page {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  \n  &.horizontal {\n    overflow: hidden;\n  }\n}\n\n.history-horizontal-layout {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.history-content-top {\n  overflow: auto;\n  border-bottom: 1px solid #e8e8e8;\n  position: relative;\n}\n\n.history-content-bottom {\n  flex: 1;\n  overflow: auto;\n  padding: 16px;\n  background-color: #f5f5f5;\n}\n\n.resize-handle {\n  width: 100%;\n  height: 10px;\n  background-color: #f0f0f0;\n  border-top: 1px solid #e0e0e0;\n  border-bottom: 1px solid #e0e0e0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: row-resize;\n  color: #999;\n  \n  &:hover {\n    background-color: #e0e0e0;\n  }\n}\n\n.selected-item-preview {\n  h3 {\n    margin-bottom: 16px;\n    font-size: 18px;\n  }\n  \n  .preview-content {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 16px;\n  }\n  \n  .preview-item {\n    background-color: white;\n    padding: 16px;\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    width: calc(33.33% - 16px);\n    min-width: 250px;\n    \n    h4 {\n      margin-bottom: 8px;\n      font-weight: 500;\n    }\n    \n    p {\n      margin-bottom: 12px;\n      color: #666;\n    }\n  }\n}\n\n.no-selection {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  color: #999;\n  font-size: 16px;\n}\n\n/* 반응형 스타일 */\n@media (max-width: 768px) {\n  .selected-item-preview .preview-item {\n    width: calc(50% - 16px);\n  }\n}\n\n@media (max-width: 576px) {\n  .selected-item-preview .preview-item {\n    width: 100%;\n  }\n}\n\n/* 스크롤바 디자인 */\n.custom-scrollbar {\n  /* Firefox */\n  scrollbar-width: thin;\n  // scrollbar-color: rgba(0, 0, 0, 0.2) transparent;\n  \n  /* Webkit 브라우저 (Chrome, Safari 등) */\n  &::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n    display: block;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: rgba(0, 0, 0, 0.2);\n    border-radius: 4px;\n    \n    &:hover {\n      background-color: rgba(0, 0, 0, 0.3);\n    }\n  }\n  \n  &::-webkit-scrollbar-button {\n    display: none !important;\n    height: 0 !important;\n    width: 0 !important;\n  }\n}\n\n/* iframe 내부 스크롤바 스타일을 위한 추가 코드 */\niframe.custom-scrollbar {\n  border: none;\n}\n\n.history-header {\n  padding: 8px 16px 8px 16px !important; /* 상단 16px, 좌우 16px, 하단 8px로 조정 */\n  margin-bottom: 0 !important; /* 하단 마진 제거 */\n}\n\n/* 또는 p-16 클래스를 오버라이드 */\n.history-header.p-16 {\n  padding-bottom: 8px !important; /* 하단 패딩만 8px로 줄임 */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
